import { Modal as MantineModal } from "@mantine/core";
import type { CustomModalContentFactory, IProps } from "./modal-content.types";
import { componentWrapper } from "../../../utilities";

const ModalContent = componentWrapper<CustomModalContentFactory, IProps>("ModalContent", (props, ref) => {
    return <MantineModal.Content ref={ref} {...props} />;
});

export { ModalContent };
